/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { PrueflaufAufgabeAntwortRequest } from '../model/prueflaufAufgabeAntwortRequest';
// @ts-ignore
import { PrueflaufAufgabeBemerkungRequest } from '../model/prueflaufAufgabeBemerkungRequest';
// @ts-ignore
import { PrueflaufAufgabeBildRequest } from '../model/prueflaufAufgabeBildRequest';
// @ts-ignore
import { PrueflaufBemerkungRequest } from '../model/prueflaufBemerkungRequest';
// @ts-ignore
import { PrueflaufBildRequest } from '../model/prueflaufBildRequest';
// @ts-ignore
import { PrueflaufIdentifier } from '../model/prueflaufIdentifier';
// @ts-ignore
import { PrueflaufRequest } from '../model/prueflaufRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PrueflaufCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostAufgabeBemerkungSetzen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * PrueflaufGeloescht: (QsChecksPrueflaufGeloescht) * PrueflaufNichtGefunden: (QsChecksPrueflaufNichtGefunden) * PruefplanNichtGefunden: (QsChecksPruefplanNichtGefunden) * KeinPrueflaufZugriff: (QsChecksKeinPrueflaufZugriff) * QsCheckModulNichtAktiv: (QsCheckModulNichtAktiv) 
     * @endpoint post /api/qs/command/prueflauf/v1/aufgabe/bemerkung
     * @param prueflaufAufgabeBemerkungRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postAufgabeBemerkungSetzen(prueflaufAufgabeBemerkungRequest: PrueflaufAufgabeBemerkungRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufIdentifier>;
    public postAufgabeBemerkungSetzen(prueflaufAufgabeBemerkungRequest: PrueflaufAufgabeBemerkungRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufIdentifier>>;
    public postAufgabeBemerkungSetzen(prueflaufAufgabeBemerkungRequest: PrueflaufAufgabeBemerkungRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufIdentifier>>;
    public postAufgabeBemerkungSetzen(prueflaufAufgabeBemerkungRequest: PrueflaufAufgabeBemerkungRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufAufgabeBemerkungRequest === null || prueflaufAufgabeBemerkungRequest === undefined) {
            throw new Error('Required parameter prueflaufAufgabeBemerkungRequest was null or undefined when calling postAufgabeBemerkungSetzen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/command/prueflauf/v1/aufgabe/bemerkung`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufAufgabeBemerkungRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostAufgabeBildEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * PrueflaufGeloescht: (QsChecksPrueflaufGeloescht) * PrueflaufNichtGefunden: (QsChecksPrueflaufNichtGefunden) * PruefplanNichtGefunden: (QsChecksPruefplanNichtGefunden) * KeinPrueflaufZugriff: (QsChecksKeinPrueflaufZugriff) * QsCheckModulNichtAktiv: (QsCheckModulNichtAktiv) 
     * @endpoint post /api/qs/command/prueflauf/v1/aufgabe/bild/entfernen
     * @param prueflaufAufgabeBildRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postAufgabeBildEntfernen(prueflaufAufgabeBildRequest: PrueflaufAufgabeBildRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufIdentifier>;
    public postAufgabeBildEntfernen(prueflaufAufgabeBildRequest: PrueflaufAufgabeBildRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufIdentifier>>;
    public postAufgabeBildEntfernen(prueflaufAufgabeBildRequest: PrueflaufAufgabeBildRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufIdentifier>>;
    public postAufgabeBildEntfernen(prueflaufAufgabeBildRequest: PrueflaufAufgabeBildRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufAufgabeBildRequest === null || prueflaufAufgabeBildRequest === undefined) {
            throw new Error('Required parameter prueflaufAufgabeBildRequest was null or undefined when calling postAufgabeBildEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/command/prueflauf/v1/aufgabe/bild/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufAufgabeBildRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostAufgabeBildHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * PrueflaufGeloescht: (QsChecksPrueflaufGeloescht) * PrueflaufNichtGefunden: (QsChecksPrueflaufNichtGefunden) * PruefplanNichtGefunden: (QsChecksPruefplanNichtGefunden) * KeinPrueflaufZugriff: (QsChecksKeinPrueflaufZugriff) * QsCheckModulNichtAktiv: (QsCheckModulNichtAktiv) 
     * @endpoint post /api/qs/command/prueflauf/v1/aufgabe/bild/hinzufuegen
     * @param prueflaufAufgabeBildRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postAufgabeBildHinzufuegen(prueflaufAufgabeBildRequest: PrueflaufAufgabeBildRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufIdentifier>;
    public postAufgabeBildHinzufuegen(prueflaufAufgabeBildRequest: PrueflaufAufgabeBildRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufIdentifier>>;
    public postAufgabeBildHinzufuegen(prueflaufAufgabeBildRequest: PrueflaufAufgabeBildRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufIdentifier>>;
    public postAufgabeBildHinzufuegen(prueflaufAufgabeBildRequest: PrueflaufAufgabeBildRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufAufgabeBildRequest === null || prueflaufAufgabeBildRequest === undefined) {
            throw new Error('Required parameter prueflaufAufgabeBildRequest was null or undefined when calling postAufgabeBildHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/command/prueflauf/v1/aufgabe/bild/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufAufgabeBildRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostAufgabePruefen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint post /api/qs/command/prueflauf/v1/aufgabe/pruefen
     * @param prueflaufAufgabeAntwortRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postAufgabePruefen(prueflaufAufgabeAntwortRequest: PrueflaufAufgabeAntwortRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufIdentifier>;
    public postAufgabePruefen(prueflaufAufgabeAntwortRequest: PrueflaufAufgabeAntwortRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufIdentifier>>;
    public postAufgabePruefen(prueflaufAufgabeAntwortRequest: PrueflaufAufgabeAntwortRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufIdentifier>>;
    public postAufgabePruefen(prueflaufAufgabeAntwortRequest: PrueflaufAufgabeAntwortRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufAufgabeAntwortRequest === null || prueflaufAufgabeAntwortRequest === undefined) {
            throw new Error('Required parameter prueflaufAufgabeAntwortRequest was null or undefined when calling postAufgabePruefen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/command/prueflauf/v1/aufgabe/pruefen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufAufgabeAntwortRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostPrueflaufBemerkungSetzen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * PrueflaufGeloescht: (QsChecksPrueflaufGeloescht) * PrueflaufNichtGefunden: (QsChecksPrueflaufNichtGefunden) * QsCheckModulNichtAktiv: (QsCheckModulNichtAktiv) 
     * @endpoint post /api/qs/command/prueflauf/v1/bemerkung
     * @param prueflaufBemerkungRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postPrueflaufBemerkungSetzen(prueflaufBemerkungRequest: PrueflaufBemerkungRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufIdentifier>;
    public postPrueflaufBemerkungSetzen(prueflaufBemerkungRequest: PrueflaufBemerkungRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufIdentifier>>;
    public postPrueflaufBemerkungSetzen(prueflaufBemerkungRequest: PrueflaufBemerkungRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufIdentifier>>;
    public postPrueflaufBemerkungSetzen(prueflaufBemerkungRequest: PrueflaufBemerkungRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufBemerkungRequest === null || prueflaufBemerkungRequest === undefined) {
            throw new Error('Required parameter prueflaufBemerkungRequest was null or undefined when calling postPrueflaufBemerkungSetzen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/command/prueflauf/v1/bemerkung`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufBemerkungRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostPrueflaufBildEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * PrueflaufGeloescht: (QsChecksPrueflaufGeloescht) * PrueflaufNichtGefunden: (QsChecksPrueflaufNichtGefunden) * QsCheckModulNichtAktiv: (QsCheckModulNichtAktiv) 
     * @endpoint post /api/qs/command/prueflauf/v1/bild/entfernen
     * @param prueflaufBildRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postPrueflaufBildEntfernen(prueflaufBildRequest: PrueflaufBildRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufIdentifier>;
    public postPrueflaufBildEntfernen(prueflaufBildRequest: PrueflaufBildRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufIdentifier>>;
    public postPrueflaufBildEntfernen(prueflaufBildRequest: PrueflaufBildRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufIdentifier>>;
    public postPrueflaufBildEntfernen(prueflaufBildRequest: PrueflaufBildRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufBildRequest === null || prueflaufBildRequest === undefined) {
            throw new Error('Required parameter prueflaufBildRequest was null or undefined when calling postPrueflaufBildEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/command/prueflauf/v1/bild/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufBildRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostPrueflaufBildHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * PrueflaufGeloescht: (QsChecksPrueflaufGeloescht) * PrueflaufNichtGefunden: (QsChecksPrueflaufNichtGefunden) * QsCheckModulNichtAktiv: (QsCheckModulNichtAktiv) 
     * @endpoint post /api/qs/command/prueflauf/v1/bild/hinzufuegen
     * @param prueflaufBildRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postPrueflaufBildHinzufuegen(prueflaufBildRequest: PrueflaufBildRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufIdentifier>;
    public postPrueflaufBildHinzufuegen(prueflaufBildRequest: PrueflaufBildRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufIdentifier>>;
    public postPrueflaufBildHinzufuegen(prueflaufBildRequest: PrueflaufBildRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufIdentifier>>;
    public postPrueflaufBildHinzufuegen(prueflaufBildRequest: PrueflaufBildRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufBildRequest === null || prueflaufBildRequest === undefined) {
            throw new Error('Required parameter prueflaufBildRequest was null or undefined when calling postPrueflaufBildHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/command/prueflauf/v1/bild/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufBildRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostPrueflaufLoeschen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * PrueflaufGeloescht: (QsChecksPrueflaufGeloescht) * PrueflaufNichtGefunden: (QsChecksPrueflaufNichtGefunden) * QsCheckModulNichtAktiv: (QsCheckModulNichtAktiv) 
     * @endpoint post /api/qs/command/prueflauf/v1/loeschen
     * @param prueflaufRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postPrueflaufLoeschen(prueflaufRequest: PrueflaufRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufIdentifier>;
    public postPrueflaufLoeschen(prueflaufRequest: PrueflaufRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufIdentifier>>;
    public postPrueflaufLoeschen(prueflaufRequest: PrueflaufRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufIdentifier>>;
    public postPrueflaufLoeschen(prueflaufRequest: PrueflaufRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufRequest === null || prueflaufRequest === undefined) {
            throw new Error('Required parameter prueflaufRequest was null or undefined when calling postPrueflaufLoeschen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/command/prueflauf/v1/loeschen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
